

import component from '@/components/inc/component';
import dictag from '@/components/inc/dictionary';
import modal from '@/components/inc/modal';
import btns from '@/components/inc/btns';
import remoteSelect from '@/components/inc/remoteSelect';


const inc = {
	install:function(Vue){
		Vue.component('load',component.load);
		Vue.component('myDownload',component.myDownload);
		Vue.component('myInput',component.myInput);
		Vue.component('gylHead',component.gylHead);
		Vue.component('gylFooter',component.gylFooter);
		Vue.component('gylFooter2',component.gylFooter2);
		Vue.component('gylCustom',component.gylCustom);
		Vue.component('dictag',dictag);
		Vue.component('selectes',dictag.selectes);
		Vue.component('in-modal',modal.inModal);
		Vue.component('in-tree',modal.inTree);
		Vue.component('btn',btns.btn);
        Vue.component('qklBtn',btns.qklBtn);
		Vue.component('remoteSelect',remoteSelect)
		Vue.component('gylSort',component.gylSort)
	}
};

export default inc;



// WEBPACK FOOTER //
// ./src/components/inc/index.js